export const up = (pageContent) => {
    const hasBgImage = Object.keys(pageContent).includes('backgroundImage');
    if (!hasBgImage) {
        pageContent.backgroundImage = {
            url: null,
            backgroundPosition: 'center',
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat'
        };
    }
    
    return pageContent;
}